import { Link } from 'react-router-dom';
import { DataTable } from '../../../../components';
import { formatDateToYYMMDD } from '../../../../utils/helper';
import {
  AdminShipment,
  GeneralShipment,
  ShipmentStatus,
} from '../../interfaces';
import { StatusChip, StatusOptionsPopup } from '../';

interface Props {
  shipmentList: GeneralShipment[] | AdminShipment[];
  loadingShipments: boolean;
  selectedStatus: string;
  onChangeStatusFilter: (status: ShipmentStatus) => void;
  isAdmin: boolean;
}

export default function ShipmentsDataTable({
  shipmentList,
  loadingShipments,
  selectedStatus,
  onChangeStatusFilter,
  isAdmin,
}: Props) {
  const headers = [
    {
      key: 'creationDate',
      text: 'Date',
      getCellContent: (value: string) => formatDateToYYMMDD(new Date(value)),
    },
    ...(isAdmin ? [{
        key: 'ffNumber',
        text: 'BC Job',
        getCellContent: (value: string) => value || 'N/A',
      }] : []
    ),
    {
      key: 'shipmentId',
      text: 'Shipment ID',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'userEmail',
      text: 'User',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'originCity',
      text: 'Origin',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'destinationCity',
      text: 'Destination',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'reference1',
      text: 'Reference 1',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'reference2',
      text: 'Reference 2',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'status',
      text: () => (
        <StatusOptionsPopup
          options={Object.values(ShipmentStatus)}
          selectedStatus={selectedStatus}
          onChangeOption={onChangeStatusFilter}
        />
      ),
      getCellContent: (status: ShipmentStatus) => (
        <StatusChip status={status}/>
      ),
    },
    {
      key: 'shipmentId',
      text: '',
      getCellContent: (value: string) => (
        <Link
          className='text-decoration-none'
          to={`/app${isAdmin ? '/admin' : ''}/shipment-history/view?shipment_id=${value}`}
        >
          <div
            className='labelText'
            style={{
              color: '#251163',
              fontSize: '16px',
              textDecoration: 'underline',
            }}
          >
            Details
          </div>
        </Link>
      ),
    },
  ];

  return (
    <div className='ShipmentsDataTable'>
      <DataTable
        headers={headers}
        data={shipmentList}
        loading={loadingShipments}
        hasPagination={false}
      />
    </div>
  );
}
